<template>
  <div class="ma-4">
    <v-toolbar class="mb-4">
      <v-menu bottom offset-y>
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            Capstone Course Evaluation Overview
            <v-icon right>fal fa-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/student/capstone/admin">
            <v-list-item-title>Capstone Course Evaluation Overview</v-list-item-title>
          </v-list-item>
          <v-list-item to="/student/capstone/admin/evals">
            <v-list-item-title>Capstone Course Evaluations</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer />
      <v-select v-model="filter" :items="filterOptions" label="Filter List" hide-details outlined dense class="mr-4" style="max-width:350px">
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.count }} Students</v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-select>
      <span>Term: {{ term }}</span>
    </v-toolbar>
    <v-card>
      <v-data-table :items="filteredStudents" :headers="headers">
        <template v-slot:item.courses="{ item }">
          <v-chip v-for="{ course, evaluation } of item.courses" :key="course" label outlined small-chip class="mr-2">
            {{ course }}
            <v-icon small right :color="evaluation ? 'success' : 'error'">fal fa-{{ evaluation ? 'check' : 'times' }}-circle</v-icon>
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { computed, onMounted, ref } from '@vue/composition-api'
import { courseList } from '@/components/student/capstone/courses'

export default {
  setup (props, { root }) {
    const user = computed(() => root.$store.state.user.spoof || root.$store.state.user)
    const isAdmin = computed(() => user.value.roles.includes('Technology Services') || user.value.roles.includes('Institutional Research'))
    const term = computed({
      get: () => root.$store.state.capstone.term,
      set: (val) => root.$store.commit('capstone/setTerm', val)
    })

    const filter = ref('')
    const filterOptions = ref([
      { text: 'All Students', value: '', count: 0 },
      { text: 'Completed', value: 'C', count: 0 },
      { text: 'Not Started', value: 'N', count: 0 },
      { text: 'Partially Completed', value: 'I', count: 0 }
    ])
    const students = ref([])
    const filteredStudents = computed(() => filter.value === '' ? students.value : students.value.filter(({ status }) => status === filter.value))
    const headers = ref([
      { text: 'Banner ID', value: 'bannerId' },
      { text: 'Last Name', value: 'last' },
      { text: 'First Name', value: 'first' },
      { text: 'Email', value: 'email' },
      { text: 'Courses', value: 'courses' }
    ])

    onMounted(async () => {
      if (!isAdmin.value) {
        root.$store.dispatch('main/snackbar', { color: 'error', text: 'You do not have permissions to access that page' })
        root.$router.replace('/student/capstone/admin')
        return
      }
      if (term.value === '') {
        const query = { type: 'Traditional', start: { $lte: new Date() }, $sort: { start: -1 }, $limit: 1 }
        const { data } = await root.$feathers.service('system/term').find({ query })
        if (data.length > 0) {
          term.value = data[0].term
        }
      }
      loadData()
    })

    async function loadData () {
      const aggregate = [
        { $match: { term: term.value } },
        { $addFields: { course: { $substr: ['$title', 0, 6] }, instructor: { $first: '$instructors' } } },
        { $match: {
          course: { $in: courseList }
        } },
        { $unwind: '$students' },
        { $project: { crn: 1, title: 1, section: 1, course: 1, name: '$students.name', pidm: '$students.pidm', instructor: '$instructor.name' } },
        { $lookup: {
          from: 'Student-CapstoneEval',
          localField: 'pidm',
          foreignField: 'pidm',
          as: 'eval'
        } },
        { $project: { pidm: 1, course: { crn: '$crn', course: '$course', evaluation: { $first: '$eval' } } } },
        { $group: {
          _id: '$pidm',
          courses: { $push: '$course' }
        } },
        { $lookup: {
          from: 'Directory',
          localField: '_id',
          foreignField: 'pidm',
          as: 'dir'
        } },
        { $addFields: { dir: { $first: '$dir' } } },
        { $project: {
          bannerId: '$dir.bannerId',
          first: '$dir.name.first',
          last: '$dir.name.last',
          email: '$dir.email',
          courses: 1
        } },
        { $sort: { last: 1, first: 1 } }
      ]
      const { data } = await root.$feathers.service('calendar/classes').find({ query: { aggregate } })
      students.value = data.map((row) => {
        row.status = 'N'
        const completed = row.courses.filter(({ evaluation }) => evaluation).length
        if (completed === row.courses.length) row.status = 'C'
        else if (completed > 0) row.status = 'I'
        return row
      })
      for (let i = 0; i < filterOptions.value.length; i++) {
        const row = filterOptions.value[i]
        const count = (row.value === '' ? students.value.length : students.value.filter(({ status }) => status === row.value).length)
        const obj = { ...row, count }
        if (count === 0) obj.disabled = true
        filterOptions.value.splice(i, 1, obj)
      }
    }

    return {
      user,
      term,
      filter,
      filterOptions,
      students,
      filteredStudents,
      headers
    }
  }
}
</script>
